import { __awaiter } from 'tslib';
import '../../../services/base/baseDiscoverService.js';
import '../../../services/base/baseV3Service.js';
import '../../../services/sgtService.js';
import '@analytics/storage-utils';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import 'react';
import '../../../utils/ErrorProvider.js';
import '../../../utils/LoaderProvider.js';
import '../../../utils/RefetchProvider.js';
import '../../../utils/NotificationProvider.js';
import '../../../utils/ContactProvider.js';
import '../../../utils/PolicyProvider.js';
import '../../../utils/AnalyticsProvider.js';
import '../../../types/AccessDevice.js';
import '../../../types/Analytics.js';
import '../../../types/CASACommunity.js';
import '../../../types/Community.js';
import '../../../types/DxSettings.js';
import '../../../types/MagicButton.js';
import '../../../types/Pannellum.js';
import '../../../types/Prospect.js';
import '../../../types/ProspectIntelligence.js';
import '../../../types/Space.js';
import '../../../types/Tour.js';
import '../../../utils/analyticsPlugin.js';
import '../../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../../utils/cookieUtils.js';
import '../../../utils/termsConditionsAgreementsUtils.js';
import '../../../services/base/analyticsV2BaseService.js';
import { getSpaceMultiresConfig } from '../../../services/spaceService.js';
import 'axios';
import '../../../services/base/casaBaseService.js';
import '../../../services/scanRequestsService.js';
import '../../../services/db/insightsReportsDB.js';
import { create } from 'zustand';

const DEFAULT_MULTIRES = {
    path: "/%l/%s%y_%x",
    fallbackPath: "/fallback/%s",
    extension: "jpg",
    tileResolution: 512,
    maxLevel: 4,
    cubeResolution: 3664,
};
const useMultiResConfig = create((set, get) => ({
    configHashes: {},
    configObjects: {},
    loadingConfigs: {},
    currentNodeStaged: true,
    getConfig(node) {
        const nodeKey = node._id + (get().currentNodeStaged && node.stagedPhoto ? "_staged" : "");
        const hash = get().configHashes[nodeKey];
        if (!hash)
            return DEFAULT_MULTIRES;
        return get().configObjects[hash] || DEFAULT_MULTIRES;
    },
    loadConfig(nodes) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentConfigObjects = get().configObjects;
            const currentConfigHashes = get().configHashes;
            function hashAndStoreConfig(node, isStaged) {
                return __awaiter(this, void 0, void 0, function* () {
                    const nodeKey = node._id + (isStaged ? "_staged" : "");
                    if (currentConfigHashes[nodeKey])
                        return;
                    set((state) => (Object.assign(Object.assign({}, state), { loadingConfigs: Object.assign(Object.assign({}, state.loadingConfigs), { [nodeKey]: true }) })));
                    try {
                        const url = isStaged ? node.stagedPhoto.multiResConfigUrl : node.photo.multiResConfigUrl;
                        const multiresConfig = yield getSpaceMultiresConfig(url);
                        const hash = yield hashConfig(multiresConfig);
                        if (!currentConfigObjects[hash]) {
                            currentConfigObjects[hash] = multiresConfig;
                        }
                        currentConfigHashes[nodeKey] = hash;
                    }
                    catch (e) {
                    }
                    finally {
                        set((state) => (Object.assign(Object.assign({}, state), { loadingConfigs: Object.assign(Object.assign({}, state.loadingConfigs), { [nodeKey]: false }) })));
                    }
                });
            }
            const promises = nodes.map((node) => __awaiter(this, void 0, void 0, function* () {
                yield hashAndStoreConfig(node, false);
                if (node.stagedPhoto) {
                    yield hashAndStoreConfig(node, true);
                }
            }));
            yield Promise.all(promises);
            set({ configObjects: currentConfigObjects, configHashes: currentConfigHashes });
        });
    },
    setStaged(staged) {
        set({ currentNodeStaged: staged });
    },
}));
function hashConfig(config) {
    return __awaiter(this, void 0, void 0, function* () {
        delete config.shtHash;
        const utf8 = new TextEncoder().encode(JSON.stringify(config));
        const hashBuffer = yield crypto.subtle.digest("SHA-256", utf8);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map((bytes) => bytes.toString(16).padStart(2, "0")).join("");
        return hashHex;
    });
}

export { useMultiResConfig };
